import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "gk_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const apiLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data;
};

export const apiMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const apiGetContent = async () => {
  const { data } = await axios.get(`${API}/cms/content`);
  return data;
};

export const apiUpdateContent = async (content) => {
  const { data } = await axios.put(
    `${API}/cms/content`,
    { content },
    { headers: authHeader() }
  );
  return data;
};

export const apiResetContent = async () => {
  const { data } = await axios.post(
    `${API}/cms/reset`,
    {},
    { headers: authHeader() }
  );
  return data;
};
